<template>
  <v-container fluid>
    <el-overlay-loading :loading="pageloading" />
    <!--mandate details  -->
    <div>
      <!-- title  -->
      <h2 class="mb-1" style="display: flex;">{{ $t('Įgaliojimo duomenys') }}<el-tooltip tooltip="IR savitarna. Pradžia. Įgaliojimų registras. Naujas įgaliojimas. Įgaliojimo duomenys" title></el-tooltip></h2>
      <v-card outlined>
        <!-- form  -->
        <v-card-text :class="showSelect ? '' : 'pa-0'">
          <v-row class="mb-0 pb-0">
            <v-col class="pb-0" cols="12" md="12">
              <el-simple-table @linkItem="linkItem" :items="dataList" />
            </v-col>
            <!-- type select -->
            <v-col v-if="showTypeSelect" cols="12" md="12" class="pb-0">
              <h4 class="mb-1" style="display: flex;">{{ $t('Pasirinkite įgaliojimo tipo grupę') }}<el-tooltip tooltip="IR savitarna. Pradžia. Įgaliojimų registras. Naujas įgaliojimas. Pasirinkite įgaliojimo tipą" subTitle></el-tooltip></h4>
                <v-btn-toggle
                  @change="searchByChange()"
                  v-model="formData.visibility"
                  mandatory
                >
                  <v-btn active-class="active-btn-group-item" small value="FIZ">
                    <v-icon style="padding-right: 4px">mdi-account</v-icon>
                    <span>{{ $t('Gyventojams') }}</span>
                  </v-btn>
                  <v-btn active-class="active-btn-group-item" small value="JUR">
                    <v-icon style="padding-right: 4px">mdi-bank</v-icon>
                    <span>{{ $t('Juridiniams asmenims') }}</span>
                  </v-btn>
                </v-btn-toggle>
            </v-col>
            <!-- select  -->
            <v-col v-if="showSelect" cols="12" md="12">
              <h4 class="mb-1" :style="getSelectedItemError" >{{ $t('Pasirinkite įgaliojimo tipą') }} <span style="color: red">*</span><el-tooltip tooltip="IR savitarna. Pradžia. Įgaliojimų registras. Naujas įgaliojimas. Pasirinkite įgaliojimo tipą" subTitle></el-tooltip></h4>
              <el-text-field
                style="display: none"
                required
                label="selectedItem"
                v-model="formData.selectedItem"
              />
              <v-list v-if="!mandateTypesLoading" subheader dense class="mandate-select-list">
                <v-list-item-group v-model="formData.selectedItem">
                  <v-list-item
                    class="mandate-select-item"
                    v-for="item in mandateTypes"
                    :key="item.id"
                  >
                    <v-list-item-content>
                      <v-list-item-title
                        v-text="getTitle(item)"
                      ></v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
              <div v-if="mandateTypesLoading && !pageloading" style="text-align: center;">
                <v-progress-circular
                :size="30"
                color="primary"
                indeterminate
                ></v-progress-circular>
            </div>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </div>
    <!--mandate service providers  -->
    <div class="pt-4" v-if="showServiceProviders">
      <!-- title  -->
      <h3 class="mb-1" style="display: flex;">{{ $t('Paslaugų teikėjai ir jų paslaugos') }}<el-tooltip tooltip="IR savitarna. Pradžia. Įgaliojimų registras. Naujas įgaliojimas. Paslaugų teikėjai ir jų paslaugos" subTitle></el-tooltip></h3>
      <v-card outlined>
        <!-- form  -->
        <!-- Mandate  -->
        <v-card-text v-if="!subMandate">
          <v-row class="mb-0 pb-0">
            <v-col style="display: flex;" class="py-0" cols="12">
                <label  :style="getServiceError"
                >{{ $t('Pasirinkite paslaugą / -as')
                }}<span style="color: red">*</span></label
              ><el-tooltip tooltip="IR savitarna. Pradžia. Įgaliojimų registras. Naujas įgaliojimas. Pasirinkite paslaugą" subTitle></el-tooltip>
            </v-col>
            <v-col class="py-0" cols="12" md="12">
              <el-text-field
                style="display: none"
                required
                label="service_input_type"
                v-model="formData.service_input_type"
              />
              <v-btn-toggle @change="onServiceTypeChange()" v-model="formData.service_input_type">
                <v-btn
                  :style="getServiceError"
                  active-class="active-btn-group-item"
                  small
                  value="by-provider"
                >
                  <v-icon style="padding-right: 4px">mdi-bank</v-icon>
                  <span>{{ $t('Ieškoti pagal paslaugų teikėją') }}</span>
                  <el-tooltip tooltip="IR savitarna. Pradžia. Įgaliojimų registras. Naujas įgaliojimas. Ieškoti pagal paslaugų teikėją" button></el-tooltip>
                </v-btn>
                <v-btn
                  :style="getServiceError"
                  active-class="active-btn-group-item"
                  small
                  value="by-service"
                >
                  <v-icon style="padding-right: 4px">mdi-magnify</v-icon>
                  <span>{{ $t('Ieškoti pagal paslaugą') }}</span>
                  <el-tooltip tooltip="IR savitarna. Pradžia. Įgaliojimų registras. Naujas įgaliojimas. Ieškoti pagal paslaugą" button></el-tooltip>
                </v-btn>
                <v-btn
                  v-if="getAllServices"
                  :style="getServiceError"
                  active-class="active-btn-group-item"
                  small
                  value="custom-service"
                >
                  <v-icon style="padding-right: 4px"
                    >mdi-pencil-box-multiple-outline</v-icon
                  >
                  <span>{{ $t('Įvesti paslaugą') }}</span>
                  <el-tooltip tooltip="IR savitarna. Pradžia. Įgaliojimų registras. Naujas įgaliojimas. Įvesti paslaugą" button></el-tooltip>
                </v-btn>
              </v-btn-toggle>
            </v-col>
            <!-- service_provider  -->
            <template v-if="showServiceProviderCard">
              <template v-if="showfullSearch">
                <v-col cols="12" md="7">
                  <el-autocomplete
                    :items="classifiers.institutionGroups"
                    direct
                    hide-details
                    itemvalue="id"
                    :itemtext="getInstitutionGroupText"
                    label="Institucijų grupė"
                    tooltip="IR savitarna. Pradžia. Įgaliojimų registras. Naujas įgaliojimas. Institucijų grupė"
                    v-model="search.institutionGroup"
                  />
                </v-col>
                <v-col cols="12" md="4"></v-col>
                <v-col class="pb-0" cols="12" md="7">
                  <el-autocomplete
                    v-if="search.institutionGroup"
                    :items="getInstitutionsByGroup"
                    direct
                    hide-details
                    itemvalue="amn_id"
                    itemtext="fullname"
                    label="Paslaugų teikėjas"
                    tooltip="IR savitarna. Pradžia. Įgaliojimų registras. Naujas įgaliojimas. Paslaugų teikėjas"
                    v-model="search.service_provider"
                  />
                  <el-autocomplete
                    v-else
                    :items="classifiers.institutions"
                    direct
                    itemvalue="value"
                    itemtext="text"
                    label="Paslaugų teikėjas"
                    tooltip="IR savitarna. Pradžia. Įgaliojimų registras. Naujas įgaliojimas. Paslaugų teikėjas"
                    v-model="search.service_provider"
                  />
                </v-col>
                <v-col class="pb-0" cols="12" md="4">
                  <el-button
                    block
                    style="height: 40px"
                    title="Pridėti instituciją"
                    :loading="loading"
                    @click.native="addServiceProvider()"
                    color="primary"
                    icon="pridėti"
                  />
                </v-col>
              </template>
              <template v-if="getAllServices">
                <v-col class="pb-0 pt-0" cols="12" md="5">
                  <el-checkbox
                    :class="showfullSearch ? 'mt-0' : 'mt-3'"
                    label="Ieškoti pagal asmens kodą"
                    tooltip="IR savitarna. Pradžia. Įgaliojimų registras. Naujas įgaliojimas. Kita institucija arba asmuo"
                    v-model="search.other_provider"
                  />
                </v-col>
              </template>
              <template v-if="!showfullSearch">
                <v-col class="pb-0 pt-2" cols="12" md="6">
                  <el-button
                    block
                    title="Ieškoti paslaugų teikėjo"
                    :loading="loading"
                    @click.native="addServiceProviderModal('provider')"
                    color="secondary"
                    icon="ieškoti"
                  />
                </v-col>
              </template>
              <!-- cards -->
              <v-col
                class="px-0"
                cols="12"
                md="12"
                v-for="(item, key) in formData.action_providers"
                :key="`${key}-${item.amn_id}-${item.type}`"
              >
                <institution-card
                  @serviceListUpdated="serviceListUpdated"
                  @removeID="removeServiceProviderModal"
                  :index="key"
                  :id="item.amn_id"
                  :formData="formData"
                ></institution-card>
              </v-col>
            </template>
            <!-- service  -->
            <template v-if="showServiceCard">
              <v-col class="pt-0" cols="12" md="12">
                <institution-services-card
                  @selected="selectedServices"
                  :formData="formData"
                  mainFilter
                ></institution-services-card>
              </v-col>
              <template v-if="showServicesList">
                <v-col cols="12" class="pb-0">
                  <h3>{{ $t('Pasirinktos paslaugos') }}</h3>
                </v-col>
                <template
                  v-for="(provider, index) in formData.action_providers"
                >
                  <template v-for="item in provider.services">
                    <v-col :key="item.id" class="pb-0 pt-2" cols="12" md="12">
                      <services-card
                        @removeServiceItem="removeServiceModal"
                        :item="item"
                        :index="index"
                        :providerType="provider.type"
                      ></services-card>
                    </v-col>
                  </template>
                </template>
              </template>
            </template>
            <!-- custom-service  -->
            <template v-if="showCustomServiceCard">
              <v-col class="pt-0" cols="12" md="12">
                <custom-services-card
                  ref="custom-services-card"
                  :formCustomData="formCustomData"
                  @addServiceProviderModal="
                    addServiceProviderModal('custom-provider')
                  "
                  @addCustomData="addCustomData()"
                ></custom-services-card>
              </v-col>
              <template v-if="showServicesList">
                <v-col cols="12" class="pb-0">
                  <h3>{{ $t('Pasirinktos paslaugos') }}</h3>
                </v-col>
                <template
                  v-for="(provider, index) in formData.action_providers"
                >
                  <template v-for="item in provider.services">
                    <v-col :key="item.id" cols="12" md="12" class="pb-0 pt-2">
                      <services-card
                        @removeServiceItem="removeServiceModal"
                        :item="item"
                        :index="index"
                        :providerType="provider.type"
                      ></services-card>
                    </v-col>
                  </template>
                </template>
              </template>
            </template>
          </v-row>
        </v-card-text>
        <!-- Sub mandate  -->
        <v-card-text v-if="subMandate">
          <v-row class="mb-0 pb-0">
            <!-- service  -->
            <template v-if="showSubCustomServiceCard">
              <template v-if="showServicesList">
                <v-col cols="12" class="pb-0">
                  <h3>{{ $t('Pasirinktos paslaugos') }}</h3>
                </v-col>
                <template
                  v-for="(provider, index) in formData.action_providers"
                >
                  <template v-for="item in provider.services">
                    <v-col
                      :key="`main-${index}-${item.id}-${item.description}`"
                      cols="12"
                      md="12"
                      class="pb-0 pt-2"
                    >
                      <services-card
                        @removeServiceItem="removeServiceSubMandate"
                        :item="item"
                        :index="index"
                        :subMandate="subMandate"
                        :providerType="provider.type"
                      ></services-card>
                    </v-col>
                  </template>
                </template>
              </template>
            </template>
          </v-row>
        </v-card-text>
      </v-card>
    </div>
    <!-- sub mandate del form  -->
    <div class="pt-4" v-if="subMandate">
       <!-- msg -->
      <h3 v-if="allServicesEndedErr" class="mb-2 text-red" style="display: flex;">{{ $t('Perįgaliojimas negali būti sudarytas, nes visos paslaugos yra pasibaigusios') }}</h3>
      <!-- title  -->
      <h3 class="mb-1">{{ $t('Pašalintos paslaugos') }}</h3>
      <v-card outlined>
        <!-- form  -->
        <v-card-text>
          <v-row class="mb-0 pb-0">
            <!-- service  -->
            <template v-for="(provider, index) in formData.action_providers">
              <template v-for="item in provider.del_services">
                <v-col :key="`del-${index}-${item.id}`" cols="12" md="12">
                  <services-card
                    deleted
                    @addServiceItem="addServiceSubMandate"
                    :item="item"
                    :index="index"
                    :providerType="provider.type"
                  ></services-card>
                </v-col>
              </template>
            </template>
          </v-row>
        </v-card-text>
      </v-card>
    </div>
    <!--Other mandate details  -->
    <div class="pt-4" v-if="showOtherMandateDetails">
      <!-- title  -->
      <h3 class="mb-1" style="display: flex;">{{ $t('Kiti įgaliojimo duomenys') }}<el-tooltip tooltip="IR savitarna. Pradžia. Įgaliojimų registras. Naujas įgaliojimas. Kiti įgaliojimo duomenys" subTitle></el-tooltip></h3>
      <v-card class="mb-1" outlined>
        <!-- form  -->
        <v-card-text class="pb-0">
          <v-row class="mb-0 pb-0">
            <!-- code  -->
            <template>
              <v-col class="pt-0" cols="12" md="12">
                <el-checkbox
                  class="mt-0 mb-1"
                  label="Suteikiama teisė perįgalioti"
                  tooltip="IR savitarna. Pradžia. Įgaliojimų registras. Naujas įgaliojimas. Suteikiama teisė perįgalioti"
                  v-model="formData.submandate_allowed"
                />
              </v-col>

              <v-col class="pb-0" cols="12" md="6">
                <el-autocomplete
                  required
                  :items="enumsClassifiers.logicSelect"
                  enums
                  itemvalue="value"
                  itemtext="text"
                  tooltip="IR savitarna. Pradžia. Įgaliojimų registras. Naujas įgaliojimas. Įgaliojimo atšaukiamumas"
                  label="Įgaliojimo atšaukiamumas"
                  v-model="formData.cancelable"
                  :hide-details="formData.cancelable == '1'"
                />
                <span class="cancelable-top" v-if="formData.cancelable == '1'">{{ $t('Įgaliotojas įgaliojimo negalės panaikinti.') }}</span><br>
                <span class="cancelable-second" v-if="formData.cancelable == '1'">{{ $t('Įgaliojimas bus išregistruotas tik pasibaigus įgaliojimo terminui arba jei įgaliojimo atsisakys įgaliotinis.') }}</span>
              </v-col>
              <v-col class="pb-0" cols="12" md="6">
                <el-autocomplete
                  required
                  :items="formatedTerms"
                  enums
                  itemvalue="value"
                  itemtext="text"
                  label="Įgaliojimo terminas"
                  tooltip="IR savitarna. Pradžia. Įgaliojimų registras. Naujas įgaliojimas. Terminas"
                  v-model="formData.term"
                />
              </v-col>
              <v-col class="pb-0" v-if="showTermDate" cols="12" md="6">
                <el-date-picker
                  required
                  :pastDate="getPastDate"
                  futureDates
                  label="Termino data"
                  tooltip="IR savitarna. Pradžia. Įgaliojimų registras. Naujas įgaliojimas. Termino data"
                  v-model="formData.term_date"
                />
              </v-col>
              <v-col class="pb-0" v-if="showTermEvent" cols="12" md="12">
                <el-textarea
                  label="Termino įvykis"
                  tooltip="IR savitarna. Pradžia. Įgaliojimų registras. Naujas įgaliojimas. Termino įvykis"
                  v-model="formData.term_event"
                  :maxlength="2000"
                  required
                />
              </v-col>
            </template>
          </v-row>
        </v-card-text
      ></v-card>

      <v-card outlined class="mt-4">
        <!-- form  -->
        <v-card-text class="pb-0">
          <v-row class="mb-0 pb-0">
            <template>
              <v-col class="pb-0 pt-0" cols="12" md="12">
                <!-- IF'as dėl tooltipo. dedant v-if ant tooltip-text rodomas tuščias kvadratas -->
                <template v-if="signatureRequiredDisabled">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <div
                        style="width: fit-content;"
                        v-bind="attrs"
                        v-on="on"
                      >
                        <el-checkbox
                          class="mt-0 mb-1"
                          disabled
                          label="Reikalingas pasirašymas kvalifikuotu el. parašu"
                          v-model="formData.signature_required"
                        />
                      </div>
                    </template>
                    <div class="tooltip-text">{{ $t('Pridėta paslauga, kuriai privalomas pasirašymas kvalifikuotu el. parašu') }}</div>
                  </v-tooltip>
                </template>
                <template v-else>
                  <el-checkbox
                    class="mt-0 mb-1"
                    label="Reikalingas pasirašymas kvalifikuotu el. parašu"
                    v-model="formData.signature_required"
                  />
                </template>
              </v-col>
            </template>
          </v-row>
        </v-card-text>
      </v-card>
    </div>
    <!-- actions  -->
    <v-card-actions>
      <v-row no-gutters>
        <v-spacer></v-spacer>
        <el-button
          v-if="!showBack"
          class="mr-1"
          color="secondary"
          title="Atgal"
          @click.native.stop="backInList()"
          :loading="loading"
        />
        <el-button
          v-if="showBack"
          class="mr-1"
          color="secondary"
          icon="atgal"
          title="Atgal"
          @click.native.stop="back()"
          :loading="loading"
        />
        <el-button
          v-if="!modeReadonly"
          title="Tęsti"
          :loading="loading"
          @click.native="next()"
          color="primary"
          icon="pirmyn"
        />
      </v-row>
    </v-card-actions>
    <!-- modal  -->
    <modal-custom
      title="Nepasirinkta nei viena paslauga"
      :text="activeServicesText"
      trueText="Taip, pašalinti ir tęsti"
      falseText="Ne, atšaukti"
      :loading="loading"
      v-model="showActiveServicesModal"
      mid
      @confirmData="confirmActiveServicesModal"
    />
    <modal-custom
      title="Pasirašymas kvalifikuotu el. parašu"
      :text="$t('Visos paslaugos reikalaujančios kvalifikuoto el. parašo buvo pašalintos. Ar jums vis dar reikalingas įgaliojimas, pasirašytas kvalifikuotu el. parašu?')"
      trueText="Taip"
      falseText="Ne"
      :loading="loading"
      v-model="showSignatureRequiredModal"
      mid
      @closeModal="removeSignatureRequired"
      @confirmData="toggleSignatureRequiredModal"
    />
    <modal-add-person
      v-if="showAddPerson"
      v-model="showAddPerson"
      :modalType="modalType"
      :additionalData="formData"
      @addPersonData="addPerson"
      hideForeignerSelect
    />
    <modal-data-lost
      v-if="showDataLost"
      v-model="showDataLost"
      title="Dėmėsio"
      text="Visi duomenys bus prarasti. Ar norite tęsti?"
      @confirmNext="confirmNext"
    />
    <modal-delete
      title="Įrašo šalinimas"
      :text="modalDeleteText"
      v-model="showDeleteModal"
      :item="modalDeleteItem"
      @confirmDelete="confirmDelete"
    />
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
import userRole from '@/mixins/userRole'
import unsavedData from '@/mixins/unsavedData'
import Enums from '@/enums'
import InstitutionCard from './components/InstitutionCard'
import InstitutionServicesCard from './components/InstitutionServicesCard'
import ServicesCard from './components/ServicesCard'
import CustomServicesCard from './components/CustomServicesCard'
import ModalAddPerson from '@/components/modals/ModalAddPerson'
import ModalDataLost from '@/components/modals/ModalDataLost'
import ModalDelete from '@/components/modals/ModalDelete'
import ModalCustom from '@/components/modals/ModalCustom'
import errorNotifications from '@/mixins/errorNotifications'

export default {
  name: 'MandateStep1',
  components: {
    InstitutionCard,
    InstitutionServicesCard,
    ServicesCard,
    CustomServicesCard,
    ModalAddPerson,
    ModalDataLost,
    ModalDelete,
    ModalCustom,
  },
  mixins: [userRole, unsavedData, errorNotifications],
  $_veeValidate: {
    validator: 'new',
  },
  data() {
    return {
      showSignatureRequiredModal: false,
      signatureRequiredDisabled: false,
      pageloading: false,
      loading: false,
      allServicesEndedErr: false,
      formData: {
        selectedItem: null,
        action_providers: [],
      },
      formCustomData: {},
      search: { institutionGroup: null },
      classifiers: {},
      enumsClassifiers: [],
      mandateTypes: {},
      showAddPerson: false,
      modalType: null,
      showDataLost: false,
      confirmSetpVal: null,
      institution: {},
      showDeleteModal: false,
      modalDeleteItem: {},
      modalDeleteText: '',
      setNotAddedtitle: '',
      mandateTypesLoading: false,
      activeServicesText: '',
      showActiveServicesModal: false,
      infoType: '',
    }
  },
  computed: {
    ...mapGetters(['getUserType']),
    showTypeSelect(){
      if(this.getId || this.getParentId){
        return false
      } else {
        return this.loggedUserFiz && this.showSelect
      }
    },
    loggedUserFiz(){
      return this.getUserType == 'FIZ'
    },
    activeServices() {
      if(this.formData.action_providers.length == 0){
        this.notAddedText()
        return false
      }
      if(this.subMandate){
        let added = this.formData.action_providers.filter((provider) => provider.services.length > 0)
        if(added.length > 0) {
          return true
        } else {
          this.notAddedText()
          return false
        }
      } else {
        let added = this.formData.action_providers.filter((provider) => provider.services.length == 0)
        this.setNotAdded(added)
        if(added.length >= 1) {
          return false
        } else {
          return true
        }
      }
    },
    formatedTerms() {
      if (this.subMandate && this.formData.original_term == '1101') {
        return this.enumsClassifiers.mandateSubterms
      } else if (this.subMandate && this.formData.original_term == '1102') {
        return this.enumsClassifiers.mandateUndefinedTerms
      } else {
        return this.enumsClassifiers.mandateTerms
      }
    },
    getRegistrationDate() {
      return (
        this.formData.registration_date ||
        this.formData.parent.registration_date
      )
    },
    getPastDate() {
      if (!this.subMandate) {
        return '9999-01-01'
      }
      if (this.formData.original_term_date) {
        return this.formData.original_term_date
      } else {
        return moment(this.getRegistrationDate)
          .add(1, 'years')
          .format('YYYY-MM-DD')
      }
    },
    getServiceError() {
      return this.errors.first('service_input_type') ? 'color: red;' : ''
    },
    getSelectedItemError() {
      return  this.errors.first('selectedItem') ? 'color: red; display: flex;' : 'display: flex;'
    },
    getInstitutionsByGroup() {
      return this.classifiers.institutionGroups.filter(
        (item) => item.id === this.search.institutionGroup
      )[0].institutions
    },
    getInstitutionGroupText() {
      return this.$i18n.locale === 'lt' ? 'title_lt' : 'title_en'
    },
    getAllServices() {
      return this.activeMandateType.all_services
    },
    showBack() {
      return !this.getId && this.activeMandateType && !this.getParentId
    },
    showfullSearch() {
      return !this.search.other_provider
    },
    getId() {
      return this.$route.params.id || null
    },
    getParentId() {
      return this.$route.params.parentId || null
    },
    modeReadonly() {
      return false
    },
    showServiceProviderCard() {
      return (
        this.formData.service_input_type === 'by-provider' && !this.pageloading
      )
    },
    showServiceCard() {
      return (
        this.formData.service_input_type === 'by-service' && !this.pageloading
      )
    },
    showCustomServiceCard() {
      return (
        this.formData.service_input_type === 'custom-service' && !this.pageloading
      )
    },
     showSubCustomServiceCard() {
      return true
    },
    showSelect() {
      return !this.activeMandateType
    },
    showServicesList() {
      return this.formData.action_providers?.length > 0
    },
    showTermEvent() {
      return this.formData.term === '1103'
    },
    showTermDate() {
      return this.formData.term === '1101'
    },
    showMandateContent() {
      return this.activeMandateType && this.activeMandateType.fields.length > 0
    },
    showServiceProviders() {
      return this.activeMandateType
    },
    showOtherMandateDetails() {
      return this.activeMandateType
    },
    getDataListType() {
      return this.subMandate
        ? this.$t('Įgaliojimas duotas perįgaliojant')
        : this.$t('Įgaliojimas')
    },
    subMandate() {
      return this.$route.name === 'subMandateSteps' || false
    },
    getJournalType() {
      return this.$route.name === 'subMandateSteps' ? '412' : '407'
    },
    activeMandateType() {
      if(this.formData.mandate_type) {
        return this.formData.mandate_type
      } else {
         return this.formData.selectedItem !== null
        ? this.mandateTypes[this.formData.selectedItem]
        : null
      }
    },
    formatedDocumentType(){
      let text = null
      if(this.formData.visibility) {
        text = this.formData.visibility == 'FIZ' ? this.$t('Gyventojams') : this.$t('Juridiniams asmenims')
      }
      let mainText =  this.formData.document_type || this.getDataListType || '-'
      return `${mainText} ${text ? ' / ' + text : ''}`
    },
    dataList() {
      return [
        {
          title: this.$t('Dokumento tipas'),
          value: this.formatedDocumentType,
          tooltip: 'IR savitarna. Pradžia. Įgaliojimų registras. Naujas įgaliojimas. Dokumento tipas'
        },
        {
          title: this.$t('Įgaliojimo tipas'),
          value:
            this.formData.text_mandate_type || this.showOtherMandateDetails
              ? this.getTitle(this.showOtherMandateDetails)
              : '-',
          tooltip: 'IR savitarna. Pradžia. Įgaliojimų registras. Naujas įgaliojimas. Įgaliojimo tipas'
        },
        {
          title: this.$t('Tėvinis įgaliojimas'),
          value: this.formData.parent?.mandate_code || this.formData.mandate_code,
          link: true,
          linkData: {id: this.formData.parent?.id || this.getParentId, tab: 'view', returnId: this.getId ? this.getId : 'parent' },
          hide: !this.subMandate,
        },
      ]
    },
  },
  created() {
    this.getData()
  },
  watch: {
    'formData.selectedItem'(newVal) {
      if(this.formData.mandate_type){
        this.formData.mandate_type_id = this.formData.mandate_type.id
      } else {
        this.formData.mandate_type_id = this.mandateTypes[newVal]?.id || null
      }
      this.formData.mandate_type_id && this.getInstitutions()
    },
  },
  methods: {
    onServiceTypeChange(){
      this.formData.action_providers.map((provider) =>{
        this.$set(provider, 'show', false)
      })
    },
    setNotAdded(added){
      this.infoType = 'modal'
      this.setNotAddedtitle = this.$t('Skiltyje "Ieškoti pagal paslaugų teikėją" nepasirinkta nei viena ')
      added.map((item) => {
        let title = ''
        let provider_type = item.type
        if (provider_type === 'amn') {
          if (item.custom) {
            title = item.institution.fullname
          } else {
            title = item.addedInstitutionData?.fullname || ''
          }
        } else {
          title = this.$t(Enums.providerType[provider_type])
        }
        this.setNotAddedtitle += title + ', '
      })
      this.setNotAddedtitle += this.$t(' paslauga. Tęsiant pridėta(-os) institucija(-os) bus pašalinta(-os). Ar norite tęsti?')
    },
    notAddedText(){
      this.infoType = 'text'
      this.setNotAddedtitle = this.$t('Turi būti pasirinkta bent viena paslauga')
    },
    linkItem(item) {
      this.$router.push({
        name: 'savMandateView',
        params: {
          id: item.linkData.id,
          tab: item.linkData.tab,
          returnId: item.linkData.returnId,
        },
      })
    },
    confirmNext() {
      this.$set(this.formData, 'service_input_type', this.confirmSetpVal)
      this.formData.action_providers = []
      this.institution = {}
      this.formData.service_provider_amn_id = null
      this.formData.service_provider = null
      this.formData.service = null
      this.showDataLost = false
    },
    getInstitutions() {
      this.pageloading = true
      let id = this.formData.mandate_type_id
      this.$axios
        .get(`mandate-types/${id}/institutions`, { params: { user_type: this.formData.visibility } })
        .then((res) => {
          this.classifiers = res.data.classifiers
          this.classifiers.institutionGroups.unshift({
            id: null,
            title_lt: 'Visos institucijos',
            title_en: 'All',
          })
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.pageloading = false
        })
    },
    formatNewCustomItem(item) {
      let newItem = {}
      newItem.action_id = null
      newItem.unique_id = `${item.service}_${Date.now().toString()}`
      newItem.institution = item.institution
      newItem.title_lt = ''
      newItem.title_en = ''
      newItem.default_description_editable = true
      newItem.description = item.service
      newItem.signature_required = false
      return newItem
    },
    formatNewItem(item) {
      let newItem = {}
      newItem.parent_id = item.parent_id
      newItem.action_id = item.id
      newItem.institution = item.institution
      newItem.title_lt = item.title_lt
      newItem.title_en = item.title_en
      newItem.default_description_editable = item.default_description_editable
      newItem.description = this.$i18n.locale === 'lt' ? item.default_description_lt : item.default_description_en
      newItem.pasis_code = item.pasis_code
      newItem.code = item.code
      newItem.signature_required = item.signature_required
      return newItem
    },
    addCustomData() {
      let item = this.formCustomData
      let actionProviderIndex = null
      if (item.service_provider === 'amn') {
        if(!item.institution?.amn_id){return}
        actionProviderIndex = this.formData.action_providers.findIndex(
          (providerItem) => providerItem.amn_id === item.institution.amn_id
        )
      } else {
        actionProviderIndex = this.formData.action_providers.findIndex(
          (providerItem) => providerItem.type === item.service_provider
        )
      }
      // not found
      if (actionProviderIndex === -1) {
        let provider = {}
        // services without institution
        if (!item.institution) {
          provider.amn_id = null
        } else {
          provider.amn_id = item.institution.amn_id
        }
        provider.institution = item.institution
        provider.type = item.service_provider
        provider.custom = true
        provider.services = []
        let newItem = this.formatNewCustomItem(item)
        provider.services.unshift(newItem)
        this.formData.action_providers.unshift(provider)
        this.formCustomData = {}
        this.$refs['custom-services-card'].clearCustomData()
        //institution found
      } else {
        let newItem = this.formatNewCustomItem(item)
        this.formData.action_providers[actionProviderIndex].services.unshift(
          newItem
        )
        this.formCustomData = {}
        this.$refs['custom-services-card'].clearCustomData()
        // first action provider
        let localActionProvider =
          this.formData.action_providers[actionProviderIndex]
        this.formData.action_providers.splice(actionProviderIndex, 1)
        this.formData.action_providers.unshift(localActionProvider)
        // }
      }
    },
    selectedServices(services) {
      services.map((item) => {
        //by provider_type
        let actionProviderIndex = null
        if (item.provider_type === 'amn') {
          actionProviderIndex = this.formData.action_providers.findIndex(
            (providerItem) => providerItem.amn_id === item.institution.amn_id
          )
        } else {
          actionProviderIndex = this.formData.action_providers.findIndex(
            (providerItem) => providerItem.type === item.provider_type
          )
        }
        // not found
        if (actionProviderIndex === -1) {
          let provider = {}
          // services without institution
          if (!item.institution) {
            provider.amn_id = null
          } else {
            provider.amn_id = item.institution.amn_id
          }

          provider.type = item.provider_type
          provider.custom = false
          provider.services = []
          provider.show = false
          let newItem = this.formatNewItem(item)
          provider.services.unshift(newItem)
          this.formData.action_providers.unshift(provider)
          // found
        } else {
          const index = this.formData.action_providers[
            actionProviderIndex
          ].services.findIndex(
            (serviceItem) => serviceItem.action_id == item.id
          )
          if (index === -1) {
            let newItem = this.formatNewItem(item)
            this.formData.action_providers[
              actionProviderIndex
            ].services.unshift(newItem)
            // set open
            this.formData.action_providers[actionProviderIndex].show = true
            // first action provider
            let localActionProvider =
              this.formData.action_providers[actionProviderIndex]
            this.formData.action_providers.splice(actionProviderIndex, 1)
            this.formData.action_providers.unshift(localActionProvider)
          }
        }
      })

      this.setSignatureRequiredDisabled();
    },
    addServiceProvider() {
      let providerCustomServices = []
      let providerCustom = false

      if (!this.search.service_provider) {
        return this.$root.$emit(
          'DATA_ERROR_CODE',
          '000104'
        )
      }
      if (
        [
          'unidentified-physical',
          'unidentified-juridical',
          'unidentified-physical-juridical',
        ].includes(this.search.service_provider)
      ) {
        if (
          this.formData.action_providers.findIndex(
            (providerItem) => providerItem.type === this.search.service_provider
          ) != -1
        ) {
           // for custom added
        let provider = this.formData.action_providers.findIndex(
          (providerItem) => providerItem.type === this.search.service_provider
        )
        if(this.formData.action_providers[provider].custom){
          providerCustom = true
          providerCustomServices = this.formData.action_providers[provider].services
          this.formData.action_providers.splice(provider, 1)
        } else {
          // else
          return this.$root.$emit(
            'DATA_ERROR_CODE',
            '000105'
          )
          }
        }
      } else if (
        this.formData.action_providers.findIndex(
          (providerItem) => providerItem.amn_id === this.search.service_provider
        ) != -1
      ) {
        // for custom added
        let provider = this.formData.action_providers.findIndex(
          (providerItem) => providerItem.amn_id === this.search.service_provider
        )
        if(this.formData.action_providers[provider].custom){
          providerCustom = true
          providerCustomServices = this.formData.action_providers[provider].services
          this.formData.action_providers.splice(provider, 1)
        } else {
          // else
          return this.$root.$emit(
            'DATA_ERROR_CODE',
            '000105'
          )
        }
      }
      let provider = {}
      // non-identified person
      if (
        [
          'unidentified-physical',
          'unidentified-juridical',
          'unidentified-physical-juridical',
        ].includes(this.search.service_provider)
      ) {
        provider.amn_id = null
        provider.type = this.search.service_provider
        provider.addFilter = true
        if (providerCustom) {
          provider.services = providerCustomService
        } else {
          provider.services = []
        }
        provider.show = true
      }
      // default
      else {
        provider.amn_id = this.search.service_provider
        provider.type = 'amn'
      }
      provider.custom = false
      if (providerCustom) {
        provider.services = providerCustomServices
      } else {
        provider.services = []
      }
      provider.show = true
      this.formData.action_providers.map(provider => {
        provider.show = false;
      })
      if(providerCustom) {
         this.$nextTick(() => {
            this.formData.action_providers.unshift(provider)
          })
      } else {
        this.formData.action_providers.unshift(provider)
      }
      this.search = { institutionGroup: null }
    },
    confirmDelete(item) {
      if (item.type === 'service-provider') {
        this.showDeleteModal = false
        this.removeServiceProvider(item.item)
      } else {
        this.showDeleteModal = false
        this.removeService(item.item)
      }
    },
    removeServiceProviderModal(item) {
      if (item.instant) {
        this.removeServiceProvider(item)
      } else {
        this.modalDeleteText = 'Ar tikrai norite pašalinti instituciją?'
        this.showDeleteModal = true
        this.modalDeleteItem = { item: item, type: 'service-provider' }
      }
    },
    removeServiceProvider(item) {
      this.pageloading = true
      if (item.id) {
        const index = this.formData.action_providers.findIndex(
          (providerItem) => providerItem.amn_id === item.id
        )
        if (index > -1) {
          this.formData.action_providers.splice(index, 1)
        }
      } else {
        const index = this.formData.action_providers.findIndex(
          (providerItem) => providerItem.type === item.providerType
        )
        if (index > -1) {
          this.formData.action_providers.splice(index, 1)
        }
      }
      this.$nextTick(() => {
        this.pageloading = false
      })

      this.serviceListUpdated()
    },
    removeSignatureRequired() {
      this.formData.signature_required = false
      this.showSignatureRequiredModal = false;
    },
    setSignatureRequiredDisabled() {
      let result = false;
      this.formData.action_providers.forEach(provider => {
        if (result == false) {
          let servicesCount = provider.services.filter(service => service.signature_required == true).length
          result = servicesCount > 0
          if (servicesCount > 0) {
            this.formData.signature_required = true;
          }
        }
      })
      this.signatureRequiredDisabled = result;
      if (result) {
        this.formData.signature_required = true;
      }
    },
    serviceListUpdated() {
      if (this.signatureRequiredDisabled) {
        let result = true
        this.formData.action_providers.forEach(provider => {
          let servicesCount = provider.services.filter(service => service.signature_required == true).length
          if (result == true) {
            result = servicesCount == 0
          }
        })
        if (result == true) {
          this.toggleSignatureRequiredModal()
        }
      }
      this.setSignatureRequiredDisabled()
    },
    toggleSignatureRequiredModal() {
      this.showSignatureRequiredModal = !this.showSignatureRequiredModal
    },
    removeServiceModal(item) {
      this.modalDeleteText = this.notificationText('000018')
      this.showDeleteModal = true
      this.modalDeleteItem = { item: item, type: 'service' }
    },
    removeService(item) {
      if (item.action_id) {
        let index = this.formData.action_providers[
          item.index
        ].services.findIndex(
          (serviceIitem) => serviceIitem.action_id === item.action_id
        )
        if (index > -1) {
          index = this.formData.action_providers[
          item.index
        ].services.findIndex(
          (serviceIitem) => serviceIitem.action_id === item.action_id
        )
          this.formData.action_providers[item.index].services.splice(index, 1)
        }
        // remove if empty
        if (this.formData.action_providers[item.index].services.length === 0) {
          this.formData.action_providers.splice(item.index, 1)
        }
      } else {
        const index = this.formData.action_providers[item.index].services.findIndex(
          (serviceIitem) => serviceIitem.unique_id === item.unique_id
        )
        if (index > -1) {
          this.formData.action_providers[item.index].services.splice(index, 1)
        }
        // remove if empty
        if (this.formData.action_providers[item.index].services.length === 0) {
          this.formData.action_providers.splice(item.index, 1)
        }
      }

      this.serviceListUpdated()
    },
    removeServiceSubMandate(item) {
      const index = this.formData.action_providers[item.index].services.findIndex(
        (servicIitem) => servicIitem.action_id === item.action_id
      )
      if (index > -1) {
        let service = this.formData.action_providers[item.index].services[index]
        this.formData.action_providers[item.index].del_services =
          this.formData.action_providers[item.index].del_services || []
        this.formData.action_providers[item.index].del_services.push(service)
        this.formData.action_providers[item.index].services.splice(index, 1)
      }

      this.serviceListUpdated()
    },
    addServiceSubMandate(item) {
      const index = this.formData.action_providers[
        item.index
      ].del_services.findIndex(
        (servicIitem) => servicIitem.action_id === item.action_id
      )
      if (index > -1) {
        let service =
          this.formData.action_providers[item.index].del_services[index]
        this.formData.action_providers[item.index].services.push(service)
        this.formData.action_providers[item.index].del_services.splice(index, 1)
      }

      this.setSignatureRequiredDisabled()
    },
    getTitle(item) {
      return this.$i18n.locale === 'lt' ? item.title_lt : item.title_en
    },
    addServiceProviderModal(type) {
      this.modalType = type
      this.showAddPerson = true
    },
    addPerson(item) {
      if (item.modalType === 'provider') {
        this.search.service_provider = item.amn_id
        this.addServiceProvider()
      } else {
        if (this.institution.amn_id === item.amn_id) {
          return this.$root.$emit(
            'DATA_ERROR_CODE',
            '000105'
          )
        }
        this.$set(this.formCustomData, 'institution', item)
        this.formCustomData.service_provider_amn_id = item.amn_id
      }
      this.showAddPerson = false
    },
    next() {
      this.saveData()
    },
    back() {
      this.formData = { selectedItem: '', action_providers: [] }
    },
    backInList() {
      if (this.subMandate) {
        let link = `${process.env.VUE_APP_SAVITARNA_GLOBAL_URL}goto.do?menuId=121`
        window.location.href = link
      } else {
        let link = `${process.env.VUE_APP_SAVITARNA_GLOBAL_URL}goto.do?menuId=122`
        window.location.href = link
      }
    },
    getData() {
      this.pageloading = true
      this.enumsClassifiers = Enums
      // edit
      if (this.getId || this.getParentId) {
        let id = this.getId ? this.getId : this.getParentId
        if (this.getParentId) {
          this.$axios
            .all([
              this.$axios.get(`mandates/${id}`),
              this.$axios.get(`mandate-types`),
            ])
            .then(
              this.$axios.spread((...responses) => {
                let responseObject = {}
                responses.forEach(
                  (response) =>
                    (responseObject = { ...responseObject, ...response.data })
                )
                this.formData = responseObject.mandate
                this.formData.cancelable = this.formData.cancelable ? '0' : '1'
                if (this.subMandate && this.getParentId) {
                  delete this.formData.parent;
                  this.formData.submandate_allowed = false
                  this.formData.cancelable = null
                  this.formData.id = null
                  // auto set
                  this.$set(this.formData, 'term', "1101")
                  if(this.formData.term_date){
                    this.$set(
                    this.formData,
                    'original_term_date',
                    this.formData.term_date
                  )
                  } else {
                    this.$set(
                      this.formData,
                      'term_date',
                      moment(this.getRegistrationDate).add(1, 'years').format('YYYY-MM-DD'))
                  }
                  this.$set(this.formData, 'original_term', this.formData.term)
                }
                this.mandateTypes = responseObject.mandateTypes
                this.formData.selectedItem = this.mandateTypes.findIndex(
                  (x) => x.id === this.formData.mandate_type.id
                )
                if([803,804,807,808,810,811,812,813,815,816].includes(this.formData.status)){
                  this.$router.push({ name: 'savDocuments' })
                }
                this.setInactivePersonServices()
              })
            )
            .then(() => {
              this.setSignatureRequiredDisabled();
            })
            .catch((err) => {
              if(err.response.status === 404){
                return this.$router.push({ name: 'sav404' })
              } else {
                this.$root.$emit('DATA_ERROR', err)
              }
            })
            .finally(() => {
              this.loading = false
              this.pageloading = false
            })
        } else {
          this.$axios
            .all([
              this.$axios.get(`in-journals/${id}`),
              this.$axios.get(`mandate-types`),
            ])
            .then(
              this.$axios.spread((...responses) => {
                let responseObject = {}
                responses.forEach(
                  (response) =>
                    (responseObject = { ...responseObject, ...response.data })
                )
                this.formData = responseObject.inJournal
                this.formData.cancelable = this.formData.cancelable ? '0' : '1'
                // this.formData.bilingual = this.formData.bilingual ? '1' : '0'
                if (this.formData.parent) {
                  this.$set(
                    this.formData,
                    'original_term_date',
                    this.formData.parent.term_date
                  )
                  this.$set(
                    this.formData,
                    'original_term',
                    this.formData.parent.term
                  )
                }
                if (this.subMandate && this.getParentId) {
                  this.formData.id = null
                }
                this.mandateTypes = responseObject.mandateTypes
                this.formData.selectedItem = this.mandateTypes.findIndex(
                  (x) => x.id === this.formData.mandate_type.id
                )
              })
            )
            .then(() => {
              this.setSignatureRequiredDisabled();
            })
            .catch((err) => {
              if(err.response.status === 404){
                return this.$router.push({ name: 'sav404' })
              } else {
                this.$root.$emit('DATA_ERROR', err)
              }
            })
            .finally(() => {
              this.loading = false
              this.pageloading = false
            })
        }
        // create
      }
      else if (!this.loggedUserFiz) {
        this.$axios
          .all([this.$axios.get(`mandate-types`), { params: { user_type: this.formData.visibility } }])
          .then(
            this.$axios.spread((...responses) => {
              let responseObject = {}
              responses.forEach(
                (response) =>
                  (responseObject = { ...responseObject, ...response.data })
              )
              this.mandateTypes = responseObject.mandateTypes
            })
          )
          .catch((err) => {
            this.$root.$emit('DATA_ERROR', err)
          })
          .finally(() => {
            this.loading = false
            this.pageloading = false
          })
      }
    },
    setInactivePersonServices(){
      if(this.subMandate){
        this.allServicesEndedErr = true;
        this.formData.action_providers.map((provider, index) => {
          provider.services.map(item => {
            if(item.service_has_ended){
              const providerIndex = this.formData.action_providers[index].services.
              findIndex((servicIitem) => servicIitem.action_id === item.action_id)
              if (providerIndex > -1) {
                let service = this.formData.action_providers[index].services[providerIndex]
                this.formData.action_providers[index].del_services = this.formData.action_providers[index].del_services || []
                this.formData.action_providers[index].del_services.push(service)
                this.formData.action_providers[index].services[providerIndex] = {};
              }
            } else {
              this.allServicesEndedErr = false;
            }
          })
          this.formData.action_providers[index].services = this.formData.action_providers[index].services.filter(item => Object.keys(item).length !== 0);
        })
      }
    },
    searchByChange(){
          this.mandateTypesLoading = true
          this.$axios
          .all([this.$axios.get(`mandate-types`, { params: { user_type: this.formData.visibility } })])
          .then(
            this.$axios.spread((...responses) => {
              let responseObject = {}
              responses.forEach(
                (response) =>
                  (responseObject = { ...responseObject, ...response.data })
              )
              this.mandateTypes = responseObject.mandateTypes
            })
          )
          .catch((err) => {
            this.$root.$emit('DATA_ERROR', err)
          })
          .finally(() => {
            this.loading = false
            this.pageloading = false
            this.mandateTypesLoading = false
          })
    },
    saveData(toRoute) {
      this.$validator.validateAll().then((res) => {
        if (res) {
          if (!this.activeServices) {
            if(this.infoType == 'modal'){
              this.activeServicesText = this.setNotAddedtitle
              this.showActiveServicesModal = true
              return
            }
            return this.$root.$emit('DATA_ERROR_DIRECT_TEXT',  this.setNotAddedtitle)
          }
          this.loading = true
          let formData = { ...this.formData }
          formData.submandate_allowed = !!this.formData.submandate_allowed
          formData.in_journal_type = this.getJournalType
          formData.parent_id = this.getParentId
          formData.cancelable = this.formData.cancelable == '1' ? '0' : '1'
          formData.signature_required = this.formData.signature_required == '1' ? '1' : '0'
          // formData.bilingual = this.formData.bilingual == '1' ? true : false
          //  clear term
          !this.showTermEvent && (formData.term_event = '')
          !this.showTermDate && (formData.term_date = '')
          let url = `in-journals/mandate-type`
          this.$axios
            .post(url, formData)
            .then((res) => {
              this.$root.$emit('DATA_OK_STEP')
              // then
              this.initialForm()
              if (toRoute) {
                this.goToRoute()
              } else {
                this.$emit('gotoStep', { step: '2', id: res.data.inJournal.id })
              }
            })
            .catch((err) => {
              this.$root.$emit('DATA_ERROR', err)
            })
            .finally(() => {
              this.loading = false
            })
        } else {
          if(this.errors.first('selectedItem')){
            this.$root.$emit('DATA_ERROR_CODE', '000099')
          } else {
            this.$root.$emit('FORMAT_ERROR_STEP')
          }
        }
      })
    },
    confirmActiveServicesModal(){
      this.formData.action_providers = this.formData.action_providers.filter(provider => provider.services.length != 0);
      this.showActiveServicesModal = false
      this.saveData()
    },
  },
}
</script>
<style lang="scss" scoped>
.n-hov {
  background-color: #f8f8f8 !important;
}

.cancelable-top{
  color: red;
}
.cancelable-second{
  color: red;
}
</style>
